import { InfoblockEffects } from './infoblock.effects';

export const effects = [InfoblockEffects];
